import * as yup from 'yup';

export const storeGoalSchema = yup.object().shape({
  amount: yup.string().required('É necessário informar um valor.'),
  goal_type: yup.string().required('É necessário informar o tipo de métrica.'),
});
